import PremiumCalculatorServices from "./PremiumCalculatorServices";
import PremiumCalculatorServicesMock from "./PremiumCalculatorServicesMock";

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? PremiumCalculatorServicesMock : PremiumCalculatorServices;
